<template>
  <div class="donate_content_headLine" @click="goDetail(boardData[0].wr_id)">
    <div class="donate_content_headLine_img" :style="`background-image:url(${returnImage(boardData[0])})`"></div>
    <div class="donate_content_headLine_textBox">
      <div class="donate_content_headLine_textBox_title">{{ boardData[0].wr_subject }}</div>
      <div class="donate_content_headLine_textBox_text" v-html="decodeHtml(boardData[0].wr_content)">
      </div>
    </div>
  </div>
</template>

<script>
import imageOption from "@/mixins/imageOption";
import util from "@/mixins/util";

export default {
  name: "BoardListPrimeLayout",
  mixins: [imageOption],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {
    boardData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {}
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    returnImage(board) {
      console.log(board.ImportantFile.MobileFile[0])
      return `${board.ImportantFile.MobileFile[0].org_url}?${this.setImageOptions(625, 424, 'jpg')}`;
    },
    decodeHtml(html = '') {
      let img_tag = /<IMG(.*?)>/gi;
      html = html.replace(img_tag, "");

      return util.htmlDecode(html);
    },
    goDetail(idx) {
      this.$router.push(`/donate/prime/${idx}`)
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>